import { get, post } from "./index";

export const sendCommercialCampaigns = async (text, phones, toast) => {
  return post("/commercial-campaigns/whatsapp/messages", { text, phones }, undefined, toast);
};